import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const truncateText = (text, maxLength) => {
   if (!text) return '';
   if (text.length <= maxLength) return text;
   return `${text.substring(0, maxLength)}...`;
};

const SingleWhyChoose = ({ galleryItem, featured }) => {
   const { img, title, subtitle } = galleryItem;

   return (
      <div className="tw-w-full tw-px-2 lg:tw-w-1/2 xl:tw-w-1/3 tw-mb-6">
         <div className={`why-choose-card${featured ? ' why-choose-card--featured' : ''}`}>
            <div className="why-choose-card__top">
               <span className="why-choose-card__badge">{title}</span>
               <Link to="/ourStory" className="why-choose-card__arrow" aria-label={`Learn more about our ${title.toLowerCase()}`}>
                  <ArrowUpRight size="18px" />
               </Link>
            </div>
            <h3 className="why-choose-card__title">{truncateText(subtitle, 70)}</h3>
            <div className="why-choose-card__image">
               <img src={img} alt="" />
            </div>
         </div>
      </div>
   );
};

export default SingleWhyChoose;
